import { render, staticRenderFns } from "./LearningItemsGridMember.vue?vue&type=template&id=17f6956c&scoped=true&"
import script from "./LearningItemsGridMember.vue?vue&type=script&lang=js&"
export * from "./LearningItemsGridMember.vue?vue&type=script&lang=js&"
import style0 from "./LearningItemsGridMember.vue?vue&type=style&index=0&id=17f6956c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f6956c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
